import { Link } from 'react-router-dom';
import { allSections, getHotArticles } from '@/utils/content';

export default function HomeHero() {
  const [featured] = getHotArticles(1);

  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-12">
        <div className="flex flex-col justify-center lg:col-span-7">
          <span className="flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-water-flash-fill" />
            五大板块 · 每天整理更新
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            17吃瓜网：按板块分区吃瓜，
            <span className="text-primary-600">不用一个个翻</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            娱乐区、社会区、科技圈、体育圈、网红圈各自成区，点进对应分区就能看到那一堆的最近八卦和话题更新。
            我们只做整理和观察，把值得一看的看点挑出来，让你几分钟就能跟上节奏。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#sections"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-apps-2-line" /> 浏览板块导航
            </a>
            <a
              href="#latest"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-400 hover:text-secondary-700"
            >
              <i className="ri-time-line" /> 查看最新更新
            </a>
          </div>

          <ul className="mt-8 flex flex-wrap gap-2">
            {allSections.map((section) => (
              <li key={section.slug}>
                <Link
                  to={`/section/${section.slug}`}
                  className="flex cursor-pointer items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3.5 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:text-sm"
                >
                  <i className={section.icon} /> {section.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {featured && (
          <div className="lg:col-span-5">
            <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative h-56 w-full overflow-hidden md:h-72">
                <img src={featured.cover} alt={featured.coverAlt} className="h-full w-full object-top" />
                <span className="absolute left-4 top-4 flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-line" /> 本周最热
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <span className="text-xs font-medium tracking-wider text-secondary-700">热门吃瓜</span>
                <h2 className="mt-2 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {featured.title}
                </h2>
                <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {featured.summary}
                </p>
                <Link
                  to={`/article/${featured.id}`}
                  className="mt-5 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  阅读全文 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}